// extracted by mini-css-extract-plugin
export var dropdown = "_qk-0";
export var imageWrapper = "_qk-3";
export var itemNameContainer = "_qk-1";
export var productImage = "_qk-2";
export var spinnerWrapper = "_qk-4";